import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T, CARD_SHADOW } from "../constants";

/* ---------- Toast ---------- */

const useToast = makeStyles({
  toast: {
    position: "fixed",
    bottom: 24,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1400,
    borderRadius: 999,
    border: `1px solid ${T.border}`,
    background: T.fg,
    color: "#fff",
    padding: "12px 20px",
    fontSize: 14,
    boxShadow: CARD_SHADOW,
    maxWidth: "90vw",
    textAlign: "center",
  },
});

export default function Toast({ children }) {
  const c = useToast();
  return <div className={c.toast}>{children}</div>;
}
